import * as React from "react";
import { userManager } from "../services/sso";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH_PROJECTS } from "../routes";

const CallbackPage: React.FC = () => {
    const history = useHistory();

    React.useEffect(() => {
        userManager.signinRedirectCallback().then(s => {
            let redirectTo = ROUTE_PATH_PROJECTS;

            //// During login we set the state to the path the user is trying to access.
            //// If it is set we will use this url instead of the default one.
            if (s.state) {
                redirectTo = s.state;
            }

            //// this will take the user to the projects home page after login.
            //// We are replacing the history so that the user cannot go back to this page and get stuck.
            history.replace(redirectTo);
        });
    });

    return <></>;
};

export default CallbackPage;
